module.exports = __webpack_public_path__ + "img/bingo_ball-81.858c31b1.png";